import {
  getCardsRequest,
  getCardsListRequests,
  uploadCardFileRequest,
  deleteCardByIdRequest,
  deleteArrCardRequest,
  userRegisterCardRequest,
  userLostCardRequest,
  getCardByIdRequest,
  patchCardCodeByIdRequest,
  restoreCardByIdRequest,
  getCardsServiceRequest,
  getAllCardsListRequests,
  createCardListRequest,
  getkindergartensCardsRequest,
  getKindergartensCardByIdRequest,
} from "@/helpers/api/cards";
import router from "@/router";
import { getKindergartenByIdRequest } from "@/helpers/api/kindergartens";
import { csvExport } from "@/helpers/CsvHelper";
import { getIdentificatorUserRole } from "../../../helpers/Constants/roles";
import querySetter from "@/helpers/QuerySetterHelper";
import { resolveObjectIdForCardsList } from "@/helpers/query/resolveObjectIdForCardsList";

const state = {
  pageCardsList: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  code: {
    code: null,
  },
  createCardFileForm: {
    file: null,
    object: null,
    disable_activation_period_expires: false,
  },
  createCardManualForm: {
    cardNumber: "",
    cardNumbers: [],
    disable_activation_period_expires: false,
    object: null,
  },
  organizationCardsList: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  cardPrice: null,
  scopedObjectId: null,
};
const getters = {
  getPageCardsList: (state) => state.pageCardsList,
  getCardsScopedObjectId: (state) => state.scopedObjectId,
  getCreateCardFileForm: (state) => state.createCardFileForm,
  getCreateCardManualForm: (state) => state.createCardManualForm,
  getOrganizationCardsList: (state) => state.organizationCardsList,
  getcardPrice: (state) => state.cardPrice,
};

const actions = {
  fetchPageCardsList(context) {
    const query = context.getters.getPageQuery.query;
    const ordering = context.getters.getOrdering;
    return new Promise((resolve, reject) => {
      getCardsRequest({
        query: {
          ordering,
          ...query,
        },
      })
        .then((response) => {
          context.commit("setCardsList", {
            listName: "pageCardsList",
            cards: response.data,
          });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchPageCardsIdList(context) {
    const query = context.getters.getPageQuery.query;
    const ordering = context.getters.getOrdering;
    const id = context.getters.getPageQuery.id;
    return new Promise((resolve, reject) => {
      getCardByIdRequest({
        id,
        query: {
          ordering,
          ...query,
        },
      })
        .then((response) => {
          context.commit("setCardsList", {
            listName: "pageCardsList",
            cards: response.data,
          });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchKindergartensPageCardsIdList(context) {
    const query = context.getters.getPageQuery.query;
    const ordering = context.getters.getOrdering;
    const cadrId = context.getters.getPageQuery.id;
    const id =
      context.getters.getKindergartenId ||
      context.getters.getCurrentOrganization;
    return new Promise((resolve, reject) => {
      getKindergartensCardByIdRequest({
        cadrId,
        id,
        query: {
          ordering,
          ...query,
        },
      })
        .then((response) => {
          context.commit("setCardsList", {
            listName: "pageCardsList",
            cards: response.data,
          });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  downloadPageCardsList(context, header) {
    const { query } = context.getters.getPageQuery;
    return new Promise((resolve, reject) => {
      getCardsRequest({ query: { ...query, limit: 5000, offset: null } })
        .then((response) => {
          csvExport(response.data, header, "Карты");
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
    // return downloadCardsListRequest({ query });
  },

  downloadReportsAllCardsList(context) {
    const { query } = context.getters.getPageQuery;
    return new Promise((resolve, reject) => {
      getAllCardsListRequests({
        data: {
          ...query,
        },
      })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  downloadReportsCardsList(context, id) {
    const { query } = context.getters.getPageQuery;

    return new Promise((resolve, reject) => {
      getCardsListRequests({
        query: { ...query, offset: null, id: id },
      })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async downloadOrganizationCardsList(context, header) {
    const { query } = context.getters.getPageQuery;
    return new Promise((resolve, reject) => {
      getkindergartensCardsRequest({
        query: {
          ...query,
          limit: 5000,
          offset: null,
        },
        id: getIdentificatorUserRole(),
      })
        .then((response) => {
          csvExport(response.data, header, "Карты");
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async fetchKindergartensCardsList(context) {
    const pageQuery = context.getters.getPageQuery;
    const { query, id } = pageQuery;
    const ordering = context.getters.getOrdering;
    const kindergartenId =
      id ||
      query.kindergarten ||
      query.organization ||
      context.getters.getCurrentOrganization ||
      getIdentificatorUserRole();

    return new Promise((resolve, reject) => {
      getkindergartensCardsRequest({
        query: { ...query, ordering },
        id: kindergartenId,
      })
        .then((response) => {
          context.commit("setCardsList", {
            listName: "organizationCardsList",
            cards: response.data,
          });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async fetchOrganizationCardsList(context) {
    const { query, id } = context.getters.getPageQuery;
    const ordering = context.getters.getOrdering;

    const kindergarten = (await getKindergartenByIdRequest({ id })).data;
    return new Promise((resolve, reject) => {
      getCardsRequest({
        query: { ...query, ordering, object: kindergarten?.object?.id },
      })
        .then((response) => {
          context.commit("setCardsList", {
            listName: "organizationCardsList",
            cards: response.data,
          });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async fetchObjectCardsList(context) {
    const { query } = context.getters.getPageQuery;
    const ordering = context.getters.getOrdering;
    const objectId = await resolveObjectIdForCardsList(context.getters);
    context.commit("setScopedObjectId", objectId);

    const filteredQuery = Object.keys(query)
      .filter((key) => !querySetter.orgNames.includes(key))
      .reduce((obj, key) => {
        obj[key] = query[key];
        return obj;
      }, {});

    return new Promise((resolve, reject) => {
      getCardsServiceRequest({
        query: { ...filteredQuery, ordering, object: objectId },
      })
        .then((response) => {
          context.commit("setCardsList", {
            listName: "organizationCardsList",
            cards: response.data,
          });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async clearCardsPage(context) {
    context.commit("clearCardsList", {
      listName: "pageCardsList",
    });
    context.commit("setScopedObjectId", null);
    return Promise.resolve();
  },
  async uploadCards(context) {
    const uploadForm = context.getters.getCreateCardFileForm;
    const formData = new FormData();
    formData.append("file", uploadForm.file);
    formData.append("object", uploadForm.object.value);
    formData.append(
      "disable_activation_period_expires",
      uploadForm.disable_activation_period_expires,
    );
    const createResult = uploadCardFileRequest({
      data: formData,
    });

    createResult.then(() => {
      router.go(-1);
      context.commit("clearCreateCardForm");
    });
    return createResult;
  },
  async editCard(context) {
    const cardId = context.state.pageCardsList.id;
    const editCard = patchCardCodeByIdRequest({
      id: cardId,
      data: { code: context.state.pageCardsList.code },
    });
    editCard.then(() => {
      router.go(-1);
      context.commit("clearCreateCardForm");
    });
    return editCard;
  },
  async createCards(context) {
    const createForm = context.getters.getCreateCardManualForm;
    const createResult = createCardListRequest({
      data: {
        card_list: createForm.cardNumbers,
        object: createForm.object.value,
        disable_activation_period_expires:
          createForm.disable_activation_period_expires,
      },
    });

    createResult.then(() => {
      router.go(-1);
      context.commit("clearCreateCardForm");
    });
    return createResult;
  },

  async deleteCards(context, { id }) {
    const prom = deleteCardByIdRequest({ id: id });
    return prom;
  },

  async deleteArrCards(context, { data }) {
    const prom = await deleteArrCardRequest({ data });
    return prom;
  },

  async addExistingCardByUser(context, { number, objId }) {
    const data = {
      object: objId,
      code: number,
    };
    const response = await userRegisterCardRequest({ data });
    if (response.status === 202) {
      context.commit("setCardPrice", response.data);
    }
    return response.data;
  },

  async lostCardUser(context, { id }) {
    return new Promise((resolve, reject) => {
      userLostCardRequest({ id })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  //востановление карты из удаленных
  async restoreCard(context, { id }) {
    return new Promise((resolve, reject) => {
      restoreCardByIdRequest({ id })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  changeEditCards(state, { fieldName, value }) {
    state.pageCardsList[fieldName] = value;
  },
  clearCreateCardForm(state) {
    state.createCardFileForm = {
      file: null,
      object: null,
      disable_activation_period_expires: false,
    };
    state.createCardManualForm = {
      cardNumber: "",
      cardNumbers: [],
      object: null,
      disable_activation_period_expires: false,
    };
  },
  setCreateCardFileForm(state, { fieldName, value }) {
    state.createCardFileForm[fieldName] = value;
  },
  setCreateCardManualForm(state, { fieldName, value }) {
    state.createCardManualForm[fieldName] = value;
  },
  deleteCardNumber(state, { id }) {
    state.createCardManualForm.cardNumbers.splice(id, 1);
  },
  addCardNumber(state, { number }) {
    state.createCardManualForm.cardNumbers.splice(0, 0, number);
  },
  setCardsList(state, { listName, cards }) {
    state[listName] = cards;
  },
  clearCardsList(state, { listName }) {
    state[listName].results = [];
  },
  setCardPrice(state, cardPrice) {
    state.cardPrice = cardPrice;
  },
  setScopedObjectId(state, objectId) {
    state.scopedObjectId = objectId;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
